var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { IsBoolean, IsDate, IsEnum, IsNumber, IsObject, IsOptional, IsString, ValidateNested, IsEmail, IsArray, IsPhoneNumber, ValidateIf, IsNotEmpty, Validate, } from "class-validator";
import { ConsentStatus, ConsentType, IdentifiedPatientLastActivityType, IdentifiedPatientState, RequestConsentError } from "./consent.dtos";
import { SearchInput } from "./search.dtos";
import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { StudyTranslationLanguage } from "./study-translation-language.dtos";
import { PatientNotificationType, StudyVersionLiteDto } from "./study.dtos";
import { ValidateNPICode } from "./npicode.validator";
export class ConditionDescription {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], ConditionDescription.prototype, "code", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ConditionDescription.prototype, "description", void 0);
export var PatientGender;
(function (PatientGender) {
    PatientGender["MALE"] = "male";
    PatientGender["FEMALE"] = "female";
    PatientGender["OTHER"] = "other";
    PatientGender["UNKNOWN"] = "unknown";
})(PatientGender || (PatientGender = {}));
export class StudyRecruitmentDto {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], StudyRecruitmentDto.prototype, "id", void 0);
__decorate([
    Type(() => SearchInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", Object)
], StudyRecruitmentDto.prototype, "query", void 0);
__decorate([
    Type(() => ConditionDescription),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Object)
], StudyRecruitmentDto.prototype, "conditionDescriptions", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], StudyRecruitmentDto.prototype, "lastUpdated", void 0);
export class UpdateRecruitmentInput {
}
__decorate([
    Type(() => SearchInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", SearchInput)
], UpdateRecruitmentInput.prototype, "query", void 0);
__decorate([
    Type(() => ConditionDescription),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateRecruitmentInput.prototype, "conditionDescriptions", void 0);
export class IdentifiedPatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], IdentifiedPatientDto.prototype, "patientId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], IdentifiedPatientDto.prototype, "mrn", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], IdentifiedPatientDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], IdentifiedPatientDto.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], IdentifiedPatientDto.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], IdentifiedPatientDto.prototype, "phone", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], IdentifiedPatientDto.prototype, "noDataAccess", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], IdentifiedPatientDto.prototype, "organizationName", void 0);
__decorate([
    IsEnum(IdentifiedPatientState),
    __metadata("design:type", String)
], IdentifiedPatientDto.prototype, "state", void 0);
__decorate([
    IsEnum(IdentifiedPatientState),
    __metadata("design:type", String)
], IdentifiedPatientDto.prototype, "addBackState", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], IdentifiedPatientDto.prototype, "hasPrescreenConsented", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], IdentifiedPatientDto.prototype, "dataDeliveryAllowed", void 0);
__decorate([
    IsEnum(RequestConsentError),
    IsOptional(),
    __metadata("design:type", String)
], IdentifiedPatientDto.prototype, "prescreeningRequestNotAllowedReason", void 0);
__decorate([
    IsEnum(RequestConsentError),
    IsOptional(),
    __metadata("design:type", String)
], IdentifiedPatientDto.prototype, "enrollmentRequestNotAllowedReason", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], IdentifiedPatientDto.prototype, "interested", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], IdentifiedPatientDto.prototype, "interestedUpdated", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Object)
], IdentifiedPatientDto.prototype, "contacted", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], IdentifiedPatientDto.prototype, "contactedUpdated", void 0);
__decorate([
    IsEnum(IdentifiedPatientLastActivityType),
    IsOptional(),
    __metadata("design:type", Object)
], IdentifiedPatientDto.prototype, "lastActivityType", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    __metadata("design:type", Object)
], IdentifiedPatientDto.prototype, "lastActivityDate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], IdentifiedPatientDto.prototype, "externalId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], IdentifiedPatientDto.prototype, "revocationReason", void 0);
__decorate([
    Type(() => StudyVersionLiteDto),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", Object)
], IdentifiedPatientDto.prototype, "consentedStudyVersion", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], IdentifiedPatientDto.prototype, "updateRecordsNeeded", void 0);
export class IdentifiedPatientsResponseDto {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], IdentifiedPatientsResponseDto.prototype, "total", void 0);
__decorate([
    Type(() => IdentifiedPatientDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], IdentifiedPatientsResponseDto.prototype, "patients", void 0);
export class IdentifiedPatientSummary {
}
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], IdentifiedPatientSummary.prototype, "NO_PRESCREEN_CONSENT", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], IdentifiedPatientSummary.prototype, "PRESCREEN_CONSENT_PENDING", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], IdentifiedPatientSummary.prototype, "PRESCREEN_CONSENTED", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], IdentifiedPatientSummary.prototype, "READY_TO_ENROLL", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], IdentifiedPatientSummary.prototype, "ENROLLING", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], IdentifiedPatientSummary.prototype, "ENROLLED", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], IdentifiedPatientSummary.prototype, "DECLINED_PRESCREEN", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], IdentifiedPatientSummary.prototype, "DECLINED_ENROLLMENT", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], IdentifiedPatientSummary.prototype, "REMOVED", void 0);
export class UpdateIdentifiedPatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateIdentifiedPatientDto.prototype, "removed", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateIdentifiedPatientDto.prototype, "mrn", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateIdentifiedPatientDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateIdentifiedPatientDto.prototype, "lastName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateIdentifiedPatientDto.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateIdentifiedPatientDto.prototype, "phone", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateIdentifiedPatientDto.prototype, "interested", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateIdentifiedPatientDto.prototype, "contacted", void 0);
__decorate([
    IsEnum(IdentifiedPatientLastActivityType),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateIdentifiedPatientDto.prototype, "lastActivityType", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateIdentifiedPatientDto.prototype, "externalId", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    Validate(ValidateNPICode),
    __metadata("design:type", Array)
], UpdateIdentifiedPatientDto.prototype, "targetedFacilities", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateIdentifiedPatientDto.prototype, "allowOnlyTargetedFacilities", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateIdentifiedPatientDto.prototype, "updateRecordsNeeded", void 0);
export class RecruitmentOverviewStats {
}
__decorate([
    IsObject(),
    __metadata("design:type", Object)
], RecruitmentOverviewStats.prototype, "totalStats", void 0);
export function initIdentifiedPatientStateCounts() {
    return {
        INFORMATION_SENT: 0,
        PRESCREEN_CONSENT_PENDING: 0,
        PRESCREEN_CONSENTED: 0,
        ENROLLING: 0,
        ENROLLING_INTERESTED: 0,
        ENROLLING_CONTACTED: 0,
        ENROLLED: 0,
        DECLINED_PRESCREEN: 0,
        DECLINED_ENROLLMENT: 0,
        REVOKED_PRESCREEN: 0,
        REVOKED_ENROLLMENT: 0,
        REMOVED: 0,
    };
}
export class PatientConsentCount {
}
__decorate([
    IsEnum(ConsentType),
    __metadata("design:type", String)
], PatientConsentCount.prototype, "consentType", void 0);
__decorate([
    IsEnum(ConsentStatus),
    __metadata("design:type", String)
], PatientConsentCount.prototype, "consentStatus", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], PatientConsentCount.prototype, "count", void 0);
export class RecruitmentWhatsNew {
}
__decorate([
    Type(() => PatientConsentCount),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], RecruitmentWhatsNew.prototype, "patientConsentCounts", void 0);
export var ContactPreferenceType;
(function (ContactPreferenceType) {
    ContactPreferenceType["EMAIL"] = "email";
    ContactPreferenceType["PHONE"] = "phone";
})(ContactPreferenceType || (ContactPreferenceType = {}));
export class PatientErrorDto {
}
__decorate([
    ApiProperty({
        description: "Index of the patient in the original request array that caused the error",
    }),
    IsNumber(),
    __metadata("design:type", Number)
], PatientErrorDto.prototype, "patientIndex", void 0);
__decorate([
    ApiProperty({
        description: "Description of the error that occurred while processing this patient",
    }),
    IsString(),
    __metadata("design:type", String)
], PatientErrorDto.prototype, "error", void 0);
export class PatientDuplicateDto {
}
__decorate([
    ApiProperty({
        description: "Index of the patient in the original request array that was a duplicate",
    }),
    IsNumber(),
    __metadata("design:type", Number)
], PatientDuplicateDto.prototype, "patientIndex", void 0);
__decorate([
    ApiProperty({
        description: "ID of the existing patient that was already in the system",
    }),
    IsString(),
    __metadata("design:type", String)
], PatientDuplicateDto.prototype, "existingPatientId", void 0);
__decorate([
    ApiProperty({
        description: "List of fields that matched the existing patient",
        type: String,
        isArray: true,
    }),
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], PatientDuplicateDto.prototype, "duplicateFields", void 0);
export class PatientSuccessDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Index of the patient in the original request array that was successfully added",
    }),
    IsNumber(),
    __metadata("design:type", Number)
], PatientSuccessDto.prototype, "patientIndex", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Email of the patient",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientSuccessDto.prototype, "email", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Phone number of the patient",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientSuccessDto.prototype, "phone", void 0);
__decorate([
    ApiPropertyOptional({
        description: "External ID of the patient",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientSuccessDto.prototype, "externalId", void 0);
__decorate([
    ApiPropertyOptional({
        description: "MRN of the patient",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientSuccessDto.prototype, "mrn", void 0);
__decorate([
    ApiProperty({
        description: "Reference ID of the patient in HealthEx",
    }),
    IsString(),
    __metadata("design:type", String)
], PatientSuccessDto.prototype, "referenceId", void 0);
export class AddPatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Last name of the patient",
    }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AddPatientDto.prototype, "lastName", void 0);
__decorate([
    ApiProperty({
        description: "First name of the patient",
    }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AddPatientDto.prototype, "firstName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "External ID of the patient",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AddPatientDto.prototype, "externalId", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Date of birth of the patient",
    }),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Date)
], AddPatientDto.prototype, "dateOfBirth", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Email of the patient",
    }),
    ValidateIf((o) => o.email && o.email.length > 0),
    IsEmail(),
    __metadata("design:type", String)
], AddPatientDto.prototype, "email", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Phone number of the patient",
    }),
    ValidateIf((o) => o.phone && o.phone.length > 0),
    IsPhoneNumber("US"),
    __metadata("design:type", String)
], AddPatientDto.prototype, "phone", void 0);
__decorate([
    ApiPropertyOptional({
        description: "MRN of the patient",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AddPatientDto.prototype, "mrn", void 0);
__decorate([
    ApiProperty({
        description: "Contact preference of the patient",
        enumName: "ContactPreferenceType",
        enum: ContactPreferenceType,
    }),
    IsEnum(ContactPreferenceType),
    __metadata("design:type", String)
], AddPatientDto.prototype, "contactPreference", void 0);
__decorate([
    ApiProperty({
        description: "Language preference of the patient",
        enumName: "StudyTranslationLanguage",
        enum: StudyTranslationLanguage,
    }),
    IsEnum(StudyTranslationLanguage),
    __metadata("design:type", String)
], AddPatientDto.prototype, "languagePreference", void 0);
__decorate([
    ApiPropertyOptional({
        description: "List of National Provider Identifier (NPI) numbers for the patient's care facilities",
        isArray: true,
    }),
    IsArray(),
    IsOptional(),
    Validate(ValidateNPICode),
    __metadata("design:type", Array)
], AddPatientDto.prototype, "targetedFacilities", void 0);
__decorate([
    ApiPropertyOptional({
        description: "When enabled, allows only facilities that are in the targetedFacilities list",
    }),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], AddPatientDto.prototype, "allowOnlyTargetedFacilities", void 0);
export class AddPatientByMRNDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "MRN of the patient for healthcare organizations",
    }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], AddPatientByMRNDto.prototype, "mrn", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Patient notification type for the patient. If not provided, defaults to enrollment requested.",
        enumName: "PatientNotificationType",
        enum: PatientNotificationType,
    }),
    IsEnum(PatientNotificationType),
    IsOptional(),
    __metadata("design:type", String)
], AddPatientByMRNDto.prototype, "patientNotificationType", void 0);
export class AddPatientsInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiPropertyOptional({
        description: "Array of patients to add to the project",
        type: AddPatientDto,
        isArray: true,
    }),
    IsArray(),
    Type(() => AddPatientDto),
    IsOptional(),
    __metadata("design:type", Array)
], AddPatientsInput.prototype, "patients", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Array of MRNs to add to the project",
        type: AddPatientByMRNDto,
        isArray: true,
    }),
    IsArray(),
    Type(() => AddPatientByMRNDto),
    IsOptional(),
    __metadata("design:type", Array)
], AddPatientsInput.prototype, "mrns", void 0);
export class AddPatientsResponseDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Total number of patients processed in the request",
    }),
    IsNumber(),
    __metadata("design:type", Number)
], AddPatientsResponseDto.prototype, "totalProcessed", void 0);
__decorate([
    ApiProperty({
        description: "Number of patients successfully added",
    }),
    IsNumber(),
    __metadata("design:type", Number)
], AddPatientsResponseDto.prototype, "successCount", void 0);
__decorate([
    ApiProperty({
        description: "Number of patients that failed to be added due to validation errors",
    }),
    IsNumber(),
    __metadata("design:type", Number)
], AddPatientsResponseDto.prototype, "errorCount", void 0);
__decorate([
    ApiProperty({
        description: "Number of patients that were duplicates and not added",
    }),
    IsNumber(),
    __metadata("design:type", Number)
], AddPatientsResponseDto.prototype, "duplicatesCount", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Array of errors that occurred during patient processing",
        type: PatientErrorDto,
        isArray: true,
    }),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PatientErrorDto),
    IsOptional(),
    __metadata("design:type", Array)
], AddPatientsResponseDto.prototype, "errors", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Array of duplicate patients that were not added",
        type: PatientDuplicateDto,
        isArray: true,
    }),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PatientDuplicateDto),
    IsOptional(),
    __metadata("design:type", Array)
], AddPatientsResponseDto.prototype, "duplicates", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PatientSuccessDto),
    IsOptional(),
    __metadata("design:type", Array)
], AddPatientsResponseDto.prototype, "successfulPatients", void 0);
export class CheckPatientExistsDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsOptional(),
    __metadata("design:type", String)
], CheckPatientExistsDto.prototype, "email", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", String)
], CheckPatientExistsDto.prototype, "phone", void 0);
export class CheckPatientsExistsInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => CheckPatientExistsDto),
    __metadata("design:type", Array)
], CheckPatientsExistsInput.prototype, "patients", void 0);
export class PatientExistsResultDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsOptional(),
    __metadata("design:type", String)
], PatientExistsResultDto.prototype, "email", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", String)
], PatientExistsResultDto.prototype, "phone", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], PatientExistsResultDto.prototype, "emailExists", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], PatientExistsResultDto.prototype, "phoneExists", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], PatientExistsResultDto.prototype, "existingPatientId", void 0);
export class CheckPatientsExistsResponseDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PatientExistsResultDto),
    __metadata("design:type", Array)
], CheckPatientsExistsResponseDto.prototype, "results", void 0);
export class UpdatePatientDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Reference ID of the patient to update",
    }),
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], UpdatePatientDto.prototype, "referenceId", void 0);
__decorate([
    ApiPropertyOptional({
        description: "First name of the patient",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdatePatientDto.prototype, "firstName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Last name of the patient",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdatePatientDto.prototype, "lastName", void 0);
__decorate([
    ApiPropertyOptional({
        description: "External ID of the patient",
    }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdatePatientDto.prototype, "externalId", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Email of the patient",
        example: "john.doe@example.com",
    }),
    ValidateIf((o) => o.email && o.email.length > 0),
    IsEmail(),
    __metadata("design:type", String)
], UpdatePatientDto.prototype, "email", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Phone number of the patient",
    }),
    ValidateIf((o) => o.phone && o.phone.length > 0),
    IsPhoneNumber("US"),
    __metadata("design:type", String)
], UpdatePatientDto.prototype, "phone", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Contact preference of the patient",
        enumName: "ContactPreferenceType",
        enum: ContactPreferenceType,
    }),
    IsEnum(ContactPreferenceType),
    IsOptional(),
    __metadata("design:type", String)
], UpdatePatientDto.prototype, "contactPreference", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Language preference of the patient",
        enumName: "StudyTranslationLanguage",
        enum: StudyTranslationLanguage,
    }),
    IsEnum(StudyTranslationLanguage),
    IsOptional(),
    __metadata("design:type", String)
], UpdatePatientDto.prototype, "languagePreference", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Targeted facilities of the patient",
        isArray: true,
    }),
    IsArray(),
    IsOptional(),
    Validate(ValidateNPICode),
    __metadata("design:type", Array)
], UpdatePatientDto.prototype, "targetedFacilities", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Exclude untargeted facilities of the patient",
    }),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdatePatientDto.prototype, "allowOnlyTargetedFacilities", void 0);
export class UpdatePatientsInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Array of patients to update in the project",
        type: UpdatePatientDto,
        isArray: true,
    }),
    IsArray(),
    Type(() => UpdatePatientDto),
    __metadata("design:type", Array)
], UpdatePatientsInput.prototype, "patients", void 0);
export class UpdatePatientsResponseDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    ApiProperty({
        description: "Total number of patients processed in the request",
    }),
    IsNumber(),
    __metadata("design:type", Number)
], UpdatePatientsResponseDto.prototype, "totalProcessed", void 0);
__decorate([
    ApiProperty({
        description: "Number of patients successfully updated",
    }),
    IsNumber(),
    __metadata("design:type", Number)
], UpdatePatientsResponseDto.prototype, "successCount", void 0);
__decorate([
    ApiProperty({
        description: "Number of patients that failed to be updated due to validation errors",
    }),
    IsNumber(),
    __metadata("design:type", Number)
], UpdatePatientsResponseDto.prototype, "errorCount", void 0);
__decorate([
    ApiPropertyOptional({
        description: "Array of errors that occurred during patient processing",
        type: PatientErrorDto,
        isArray: true,
    }),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PatientErrorDto),
    IsOptional(),
    __metadata("design:type", Array)
], UpdatePatientsResponseDto.prototype, "errors", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => PatientSuccessDto),
    IsOptional(),
    __metadata("design:type", Array)
], UpdatePatientsResponseDto.prototype, "successfulPatients", void 0);
